// extracted by mini-css-extract-plugin
export var buttonContainer = "_9d-1";
export var fontSizeSelect = "_9d-3";
export var formatSelect = "_9d-2";
export var formats = "_9d-4";
export var hidden = "_9d-5";
export var icon = "_9d-6";
export var select = "_9d-0";